import './css/Footer.css'
import LogoWhite from './img/logo_sotec_w.png'
import Text from './Text'


function Footer() {
    return (
        <div className='footer'>
            <div className='darkgray' style={{ height: '194px', alignContent: 'center' }}>
                <div className='logo2'>
                    <img src={LogoWhite} style={{ width: '100%', height: '100%', display: 'block' }} />
                </div>
                <div className='footer_UpinfoBox'>
                    <Text variant='px20w400' style={{ color: '#FFFFFF', fontFamily: 'Pretendard', fontWeight: '200' }}>Contact us</Text>

                    <table style={{ borderSpacing: ' 0 10px' }}>
                        <tr>
                            <td><Text variant='px14' style={{ width: '100px', textAlign: 'left', color: '#FFFFFF', fontWeight: '200', display: 'block' }}>Address</Text></td>
                            <td><Text variant='px14' style={{ width: '100px', textAlign: 'left', color: '#FFFFFF', fontWeight: '200', opacity: '0.5' }}>[53262] 경상남도 거제시 장평3로 75(장평동) 설계지원 센터 2관</Text></td>
                        </tr>
                        <tr  >
                            <td><Text variant='px14' style={{ width: '100px', color: '#FFFFFF', fontWeight: '200' }}>Tel</Text></td>
                            <td><Text variant='px14' style={{ color: '#FFFFFF', opacity: '0.5', fontWeight: '200' }}>055.630.8723</Text></td>
                        </tr>
                    </table>
                </div>
            </div>
            <div className='black' style={{ height: '46px' }}>
                <Text variant='px14' className={'footer_DownReserve'} style={{ fontWeight: '200', color: '#FFFFFF' }}>@2012 Sotec Corp. All rights reserverd.</Text>
            </div>
        </div>
    );
}

export default Footer;